const styles = {
  agentAvatar: "agent-gui-node__agent-avatar",
  agentAvatarBadge: "agent-gui-node__agent-avatar-badge",
  agentAvatarBadgeImage: "agent-gui-node__agent-avatar-badge-image",
  agentAvatarImage: "agent-gui-node__agent-avatar-image",
  bottomDock: "agent-gui-node__bottom-dock",
  bottomDockPrompt: "agent-gui-node__bottom-dock-prompt",
  bottomDockScrollToBottom: "agent-gui-node__bottom-dock-scroll-to-bottom",
  body: "agent-gui-node__body",
  composer: "agent-gui-node__composer",
  composerChip: "agent-gui-node__composer-chip",
  composerControlsRow: "agent-gui-node__composer-controls-row",
  composerFooter: "agent-gui-node__composer-footer",
  composerFooterAccessory: "agent-gui-node__composer-footer-accessory",
  composerFooterLeft: "agent-gui-node__composer-footer-left",
  composerFooterRight: "agent-gui-node__composer-footer-right",
  composerHero: "agent-gui-node__composer-hero",
  composerFloatingPrompt: "agent-gui-node__composer-floating-prompt",
  composerDisclosurePanel: "agent-gui-chrome__composer-disclosure-panel",
  composerFileDropOverlay: "agent-gui-node__composer-file-drop-overlay",
  composerFileDropOverlayActive:
    "agent-gui-node__composer-file-drop-overlay--active",
  composerFileDropOverlayCard:
    "agent-gui-node__composer-file-drop-overlay-card",
  composerHandoffIcon: "agent-gui-node__composer-handoff-icon",
  composerHandoffAnimatedIcon: "agent-gui-node__composer-handoff-icon-animated",
  composerHandoffMenuContent: "agent-gui-node__composer-handoff-menu-content",
  composerHandoffStaticIcon: "agent-gui-node__composer-handoff-icon-static",
  composerHandoffTrigger: "agent-gui-node__composer-handoff-trigger",
  composerQueuedPromptFloating:
    "agent-gui-node__composer-floating-prompt--queued",
  composerInputGroup: "agent-gui-node__composer-input-group",
  composerInputGroupHero: "agent-gui-node__composer-input-group-hero",
  composerInputShell: "agent-gui-node__composer-input-shell",
  composerInputShellHero: "agent-gui-node__composer-input-shell-hero",
  composerMenuTrigger: "agent-gui-node__composer-menu-trigger",
  composerTuttiModeIcon: "agent-gui-node__composer-tutti-mode-icon",
  composerTuttiModeIconStatic:
    "agent-gui-node__composer-tutti-mode-icon-static",
  composerTuttiModeIconAnimated:
    "agent-gui-node__composer-tutti-mode-icon-animated",
  composerMenuContent: "agent-gui-node__composer-menu-content",
  composerMenuLabel: "agent-gui-node__composer-menu-label",
  composerMenuItem: "agent-gui-node__composer-menu-item",
  composerMenuItemMeta: "agent-gui-node__composer-menu-item-meta",
  composerPromptTip: "agent-gui-node__composer-prompt-tip",
  composerPromptTipItem: "agent-gui-node__composer-prompt-tip-item",
  composerPromptTipLabel: "agent-gui-node__composer-prompt-tip-label",
  composerPromptTipPrefix: "agent-gui-node__composer-prompt-tip-prefix",
  composerPromptTipTrack: "agent-gui-node__composer-prompt-tip-track",
  composerPromptTips: "agent-gui-node__composer-prompt-tips",
  composerPromptTipText: "agent-gui-node__composer-prompt-tip-text",
  composerPromptTipTooltip: "agent-gui-node__composer-prompt-tip-tooltip",
  composerProjectControls: "agent-gui-node__composer-project-controls",
  composerProjectRow: "agent-gui-node__composer-project-row",
  composerProjectTrigger: "agent-gui-node__composer-project-trigger",
  composerProviderSelect: "agent-gui-node__composer-provider-select",
  composerQueuedPromptCard: "agent-gui-node__composer-queued-prompt-card",
  composerQueuedPromptHeader: "agent-gui-node__composer-queued-prompt-header",
  composerQueuedPromptExpandCue:
    "agent-gui-node__composer-queued-prompt-expand-cue",
  composerQueuedPromptList: "agent-gui-node__composer-queued-prompt-list",
  composerQueuedPromptMain: "agent-gui-node__composer-queued-prompt-main",
  composerQueuedPromptPanel: "agent-gui-node__composer-queued-prompt-panel",
  composerQueuedPromptRow: "agent-gui-node__composer-queued-prompt-row",
  composerQueuedPromptBody: "agent-gui-node__composer-queued-prompt-body",
  composerQueuedPromptImages: "agent-gui-node__composer-queued-prompt-images",
  composerQueuedPromptImage: "agent-gui-node__composer-queued-prompt-image",
  composerQueuedPromptLabel: "agent-gui-node__composer-queued-prompt-label",
  composerQueuedPromptCount: "agent-gui-node__composer-queued-prompt-count",
  composerQueuedPromptText: "agent-gui-node__composer-queued-prompt-text",
  composerQueuedPromptActions: "agent-gui-node__composer-queued-prompt-actions",
  composerReferenceTrigger: "agent-gui-node__composer-reference-trigger",
  composerSendButton: "agent-gui-node__composer-send-button",
  composerStopButton: "agent-gui-node__composer-stop-button",
  composerSelect: "agent-gui-node__composer-select",
  composerTextarea: "agent-gui-node__composer-textarea",
  composerToggle: "agent-gui-node__composer-toggle",
  conversationDeleteButton: "agent-gui-node__conversation-delete-button",
  conversationDeleteConfirmText:
    "agent-gui-node__conversation-delete-confirm-text",
  conversationActions: "agent-gui-node__conversation-actions",
  conversationActivitySecondary:
    "agent-gui-node__conversation-activity-secondary",
  conversationActivitySecondaryIcon:
    "agent-gui-node__conversation-activity-secondary-icon",
  conversationActivityText: "agent-gui-node__conversation-activity-text",
  conversationItem: "agent-gui-node__conversation-item",
  conversationList: "agent-gui-node__conversation-list",
  conversationMeta: "agent-gui-node__conversation-meta",
  conversationMoreButton: "agent-gui-node__conversation-more-button",
  conversationProviderImage: "agent-gui-node__conversation-provider-image",
  conversationProviderIcon: "agent-gui-node__conversation-provider-icon",
  conversationProviderMaskIcon:
    "agent-gui-node__conversation-provider-mask-icon",
  conversationOpenWindowButton:
    "agent-gui-node__conversation-open-window-button",
  conversationPinButton: "agent-gui-node__conversation-pin-button",
  conversationSection: "agent-gui-node__conversation-section",
  conversationSectionActionTooltip:
    "agent-gui-node__conversation-section-action-tooltip",
  conversationSectionActionTooltipWrap:
    "agent-gui-node__conversation-section-action-tooltip-wrap",
  conversationSectionActions: "agent-gui-node__conversation-section-actions",
  conversationSectionChevron: "agent-gui-node__conversation-section-chevron",
  conversationSectionEmpty: "agent-gui-node__conversation-section-empty",
  conversationSectionHeader: "agent-gui-node__conversation-section-header",
  conversationSectionItems: "agent-gui-node__conversation-section-items",
  conversationSectionItemsInner:
    "agent-gui-node__conversation-section-items-inner",
  conversationSectionLabel: "agent-gui-node__conversation-section-label",
  conversationSectionLabelIcon:
    "agent-gui-node__conversation-section-label-icon",
  conversationSectionMoreButton:
    "agent-gui-node__conversation-section-more-button",
  conversationSectionPagination:
    "agent-gui-node__conversation-section-pagination",
  conversationSectionPaginationButton:
    "agent-gui-node__conversation-section-pagination-button",
  conversationSectionToggle: "agent-gui-node__conversation-section-toggle",
  projectDragImage: "agent-gui-node__project-drag-image",
  pinnedProjectRailHeader: "agent-gui-node__pinned-project-rail-header",
  conversationSelect: "agent-gui-node__conversation-select",
  conversationStatusGlyph: "agent-gui-node__conversation-status-glyph",
  conversationTime: "agent-gui-node__conversation-time",
  conversationWorktreeGlyph: "agent-gui-node__conversation-worktree-glyph",
  conversationTitle: "agent-gui-node__conversation-title",
  conversationTitleRow: "agent-gui-node__conversation-title-row",
  conversationUnreadLamp: "agent-gui-node__conversation-unread-lamp",
  detail: "agent-gui-node__detail",
  detailPrimary: "agent-gui-node__detail-primary",
  detailPanel: "agent-gui-node__detail-panel",
  detailWorkbench: "agent-gui-node__detail-workbench",
  empty: "agent-gui-node__empty",
  emptyHero: "agent-gui-node__empty-hero",
  emptyHeroBody: "agent-gui-node__empty-hero-body",
  emptyHeroCarousel: "agent-gui-node__empty-hero-carousel",
  emptyHeroCarouselCanvas: "agent-gui-node__empty-hero-carousel-canvas",
  emptyHeroCarouselItem: "agent-gui-node__empty-hero-carousel-item",
  emptyHeroCarouselLayer: "agent-gui-node__empty-hero-carousel-layer",
  emptyHeroCarouselPlaceholder:
    "agent-gui-node__empty-hero-carousel-placeholder",
  emptyHeroCarouselStage: "agent-gui-node__empty-hero-carousel-stage",
  emptyHeroIconEffect: "agent-gui-node__empty-hero-icon-effect",
  emptyHeroProvider: "agent-gui-node__empty-hero-provider",
  emptyHeroProviderSelect: "agent-gui-node__empty-hero-provider-select",
  emptyHeroTitle: "agent-gui-node__empty-hero-title",
  emptyHeroSuggestions: "agent-gui-node__empty-hero-suggestions",
  emptyHeroSuggestionsChips: "agent-gui-node__empty-hero-suggestions-chips",
  emptyHeroSuggestionsChip: "agent-gui-node__empty-hero-suggestions-chip",
  emptyHeroSuggestionsChipIcon:
    "agent-gui-node__empty-hero-suggestions-chip-icon",
  emptyHeroSuggestionsCard: "agent-gui-node__empty-hero-suggestions-card",
  emptyHeroSuggestionsCardHeader:
    "agent-gui-node__empty-hero-suggestions-card-header",
  emptyHeroSuggestionsCardTitle:
    "agent-gui-node__empty-hero-suggestions-card-title",
  emptyHeroSuggestionsCardClose:
    "agent-gui-node__empty-hero-suggestions-card-close",
  emptyHeroSuggestionsItem: "agent-gui-node__empty-hero-suggestions-item",
  emptyProviderGate: "agent-gui-node__empty-provider-gate",
  emptyProviderGateAction: "agent-gui-node__empty-provider-gate-action",
  emptyProviderGateDescription:
    "agent-gui-node__empty-provider-gate-description",
  emptyProviderGateStatus: "agent-gui-node__empty-provider-gate-status",
  emptyState: "agent-gui-node__empty-state",
  conversationRailLoadError: "agent-gui-node__conversation-rail-load-error",
  conversationRailLoadErrorIcon:
    "agent-gui-node__conversation-rail-load-error-icon",
  unavailableChatEmpty: "agent-gui-node__unavailable-chat-empty",
  unavailableChatEmptyIcon: "agent-gui-node__unavailable-chat-empty-icon",
  unavailableChatEmptyText: "agent-gui-node__unavailable-chat-empty-text",
  layout: "agent-gui-node__layout",
  messageBubble: "agent-gui-node__message-bubble",
  newConversationIconButton: "agent-gui-node__new-conversation-icon-button",
  projectRailAddProject: "agent-gui-node__project-rail-add-project",
  projectRailAddProjectIcon: "agent-gui-node__project-rail-add-project-icon",
  projectRailAddProjectTrigger:
    "agent-gui-node__project-rail-add-project-trigger",
  projectRailHeader: "agent-gui-node__project-rail-header",
  projectRailTitle: "agent-gui-node__project-rail-title",
  providerRail: "agent-gui-node__provider-rail",
  providerRailAvatar: "agent-gui-node__provider-rail-avatar",
  providerRailBetaBadge: "agent-gui-node__provider-rail-beta-badge",
  providerRailAvatarIcon: "agent-gui-node__provider-rail-avatar-icon",
  providerRailAvatarImage: "agent-gui-node__provider-rail-avatar-image",
  emptyHeroIconSlot: "agent-gui-node__empty-hero-icon-slot",
  providerRailConfigButton: "agent-gui-node__provider-rail-config-button",
  providerRailConfigFooter: "agent-gui-node__provider-rail-config-footer",
  providerRailFooter: "agent-gui-node__provider-rail-footer",
  providerRailPanel: "agent-gui-node__provider-rail-panel",
  providerRailSidebarFooter: "agent-gui-node__provider-rail-sidebar-footer",
  providerRailSeparator: "agent-gui-node__provider-rail-separator",
  providerRailTile: "agent-gui-node__provider-rail-tile",
  providerRailTileLabel: "agent-gui-node__provider-rail-tile-label",
  rail: "agent-gui-node__rail",
  railPanel: "agent-gui-node__rail-panel",
  railPanelCollapsed: "agent-gui-node__rail-panel--collapsed",
  railResizeHandle: "agent-gui-node__rail-resize-handle",
  railResizeHandleCollapsed: "agent-gui-node__rail-resize-handle--collapsed",
  railToolbar: "agent-gui-node__rail-toolbar",
  activityEmpty: "agent-gui-node__activity-empty",
  activityHeading: "agent-gui-node__activity-heading",
  activityToggleButton: "agent-gui-node__activity-toggle-button",
  activityToggleDot: "agent-gui-node__activity-toggle-dot",
  rowMeta: "agent-gui-node__row-meta",
  shell: "agent-gui-node__shell",
  sideCloseButton: "agent-gui-node__side-close-button",
  sideComposer: "agent-gui-node__side-composer",
  sideEmptyState: "agent-gui-node__side-empty-state",
  sideEmptyStateDescription: "agent-gui-node__side-empty-state-description",
  sideEmptyStateIcon: "agent-gui-node__side-empty-state-icon",
  sideEmptyStateTitle: "agent-gui-node__side-empty-state-title",
  sideError: "agent-gui-node__side-error",
  sideHeader: "agent-gui-node__side-header",
  sidePane: "agent-gui-node__side-pane",
  sideResizeHandle: "agent-gui-node__side-resize-handle",
  sideSurface: "agent-gui-node__side-surface",
  sideTimeline: "agent-gui-node__side-timeline",
  sideTimelineFrame: "agent-gui-node__side-timeline-frame",
  timeline: "agent-gui-node__timeline",
  timelineCentered: "agent-gui-node__timeline-centered",
  timelineScrolledFromTop: "agent-gui-node__timeline--scrolled-from-top",
  transcriptSkeleton: "agent-gui-node__transcript-skeleton",
  transcriptSkeletonBubble: "agent-gui-node__transcript-skeleton-bubble",
  transcriptSkeletonLine: "agent-gui-node__transcript-skeleton-line",
  transcriptSkeletonLineLong: "agent-gui-node__transcript-skeleton-line-long",
  transcriptSkeletonLineMedium:
    "agent-gui-node__transcript-skeleton-line-medium",
  transcriptSkeletonLineShort: "agent-gui-node__transcript-skeleton-line-short",
  transcriptSkeletonRow: "agent-gui-node__transcript-skeleton-row",
  transcriptSkeletonRowAssistant:
    "agent-gui-node__transcript-skeleton-row-assistant",
  transcriptSkeletonRowUser: "agent-gui-node__transcript-skeleton-row-user",
  timelineUnavailableChatEmpty:
    "agent-gui-node__timeline-unavailable-chat-empty",
  timelineRow: "agent-gui-node__timeline-row",
  timelineWithComposer: "agent-gui-node__timeline-with-composer",
  windowAgentInfo: "agent-gui-node__window-agent-info"
} as const;

export default styles;
